import { Signal } from '@angular/core';

export abstract class KeyboardService {
  abstract readonly keyboardHeight: Signal<number>;
  abstract readonly isKeyboardOpen: Signal<boolean>;
  abstract init(): void;
}
